import React, { useEffect, useState } from 'react';
import { FaCheckSquare } from "react-icons/fa";

const DayCard = ({ day, title, description, items }) => (
  <div
    style={{
      background: "#f8cb4e",
      borderRadius: "20px",
      padding: "20px",
      flex: "1 1 300px",
      maxWidth: "400px",
      margin: "10px",
      boxShadow: "0 0 20px rgba(0,0,0,0.2)",
    }}
  >
    <div
      style={{
        background: "#fff",
        borderRadius: "12px",
        padding: "10px",
        color: "#003D16",
        fontWeight: "bold",
        marginBottom: "20px",
        fontSize: "18px",
        textAlign: "center",
        boxShadow: "0 0 10px #0f0",
      }}
    >
      <span style={{ textDecoration: "underline" }}>{day}</span> <br />
      {title} <span role="img" aria-label="brain">🧠</span>
    </div>

    <p
      style={{
        textAlign: "left",
        fontSize: "15px",
        marginBottom: "20px",
        lineHeight: "1.6",
        color: "#000",
      }}
    >
      <FaCheckSquare style={{ marginRight: "8px", color: "#000" }} />
      {description}
    </p>

    {items.map((item, idx) => (
      <div key={idx}>
        <div
          style={{
            background: "#06145c",
            color: "#fff",
            borderRadius: "10px",
            padding: "8px 12px",
            fontWeight: "bold",
            fontSize: "15px",
            margin: "15px 0 5px",
          }}
        >
          {item.title}
        </div>
        <div
          style={{
            background: "#fff",
            borderRadius: "10px",
            padding: "10px",
            fontSize: "14px",
            lineHeight: "1.5",
            color:'#000'
          }}
        >
          {item.text}
        </div>
      </div>
    ))}
  </div>
);

const Masterclass = () => {
    const [isMobile, setIsMobile] = useState(false);
    
      useEffect(() => {
        const checkMobile = () => {
          setIsMobile(window.innerWidth <= 768);
        };
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
      }, []);
    
  return (
    <div
      style={{
        background: "linear-gradient(180deg, #000b3e 0, #020202 59%)",
        color: "#fff",
        textAlign: "center",
        padding: "50px 20px",
        fontFamily: "Outfit, sans-serif",
      }}
    >
      <h2
        style={{
          fontSize: "28px",
          fontWeight: "900",
          marginBottom: "40px",
        }}
      >
        या 2-day masterclass मध्ये तुम्ही काय experience कराल:
      </h2>

      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          gap: "0px",
        }}
      >
        <DayCard
          day="Day 1"
          title="The Science of Manifestation"
          description="आपल्या brain, thoughts आणि emotions एकमेकांशी कसे interact करून reality create करतात हे जाणून घ्या. Practical exercises द्वारे तुमचे negative thoughts आणि limiting beliefs कसे release करायचे ते शिकाल."
          items={[
            {
              title: "#1: Understanding Brainwaves",
              text: "आपल्या brain, thoughts आणि emotions एकमेकांशी कसे interact करून reality create करतात हे जाणून घ्या. Practical exercises द्वारे तुमचे negative thoughts आणि limiting beliefs कसे release करायचे ते शिकाल.",
            },
            {
              title: "#2: Reprogramming the Subconscious Mind",
              text: "Subconscious mind ची mechanics समजून घ्या आणि तुमच्या daily actions वर 95% control कसा ठेवता येतो ते जाणून घ्या.",
            },
            {
              title: "#3: Visualization Techniques",
              text: "तुम्हाला HD Visualization कसं करायचं आणि तुमचे desires universe आणि subconscious mind ला कसे signal करायचे ते शिकाल.",
            },
          ]}
        />

        <DayCard
          day="Day 2"
          title="Applying Techniques to Manifestation"
          description="हा दिवस practical आणि action-oriented आहे. तुम्ही तुमच्या daily life मध्ये हे manifestation tools कसे effectively वापरायचे ते शिकाल."
          items={[
            {
              title: "#4: Affirmations आणि Gratitude Journaling",
              text: "तुमच्या subconscious level वर काम करणाऱ्या powerful affirmations कसे तयार करायचे ते शिकाल. Gratitude journaling द्वारे तुमचा vibration कसा वाढवायचा हे देखील शिकाल.",
            },
            {
              title: "#5: Emotional Alignment",
              text: "तुमच्या desires शी align होणाऱ्या भावनांचा वापर कसा करायचा हे शिकून घेऊन तुमची manifestation process कशी speed up करायची ते जाणून घ्या.",
            },
            {
              title: "#6: Taking Inspired Action",
              text: "Inspired action कधी आणि कसं घ्यायचं हे जाणून घेऊन तुमचे goals पूर्ण करा.",
            },
          ]}
        />
      </div>
      <div style={{ textAlign: 'center', marginTop: '40px' }}>
            <button style={{
              background: 'linear-gradient(49.12deg, #ffc74b 0, #e39600 22%)',
              color: 'white',
              fontSize: isMobile ? '18px' : '20px',
              padding: isMobile ? '10px 40px' : '25px 80px',
              border: 'none',
              borderRadius: '20px',
              fontWeight: 'bold',
              cursor: 'pointer',
              width: isMobile ? '100%' : 'auto',
            }}>
              Join The 2 Day Workshop for ₹199 &nbsp;
              <span style={{ textDecoration: 'line-through', opacity: 0.8 }}>₹999</span> 
            </button>
            <p style={{
              marginTop: '10px',
              color: 'white',
              fontSize: '16px',
              fontFamily: 'outfit,sans-serif',
              fontStyle:'italic'
            }}>
              Registrations End on <span style={{ fontWeight: 'bold', color: 'red' }}>11 JUL</span> <br/>
              100% मनी बॅक गॅरंटी | समाधानी नसल्यास
            </p>
          </div>
    </div>
  );
};

export default Masterclass;
